import { useEffect } from 'react';
import HeroSection from '@/components/HeroSection';
import Marquee from '@/components/Marquee';
import DestinationGrid from '@/components/DestinationGrid';
import MarketCTA from '@/components/MarketCTA';

export default function HomePage({ started }) {
  useEffect(() => {
    document.title = 'ARC TOONS — The Cartoon Universe of Arc';
  }, []);

  return (
    <>
      <HeroSection started={started} />
      <Marquee />
      <DestinationGrid />
      <MarketCTA />
    </>
  );
}
